import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  rememberPrelaunchPendingPath,
  shouldGatePathname,
  usePrelaunchGateState,
} from "../../features/public/siteMode";

function buildLocationTarget(location) {
  return `${location.pathname || "/"}${location.search || ""}${location.hash || ""}`;
}

export default function PrelaunchGate({ children }) {
  const location = useLocation();
  const prelaunchAccess = usePrelaunchGateState();
  const isGated = shouldGatePathname(location.pathname);

  if (prelaunchAccess.status === "checking") {
    return null;
  }

  if (isGated) {
    rememberPrelaunchPendingPath(buildLocationTarget(location));
    return <Navigate to="/" replace />;
  }

  return children;
}
